<template>
  <div class="flex flex-col gap-6 max-w-md">
    <!-- Main title -->
    <Typography size="main-xl-2" class="text-center leading-none text-wrap text-white font-bold">
      Elegibility Checker
    </Typography>
    
    <div class="flex flex-col gap-2">
      <Typography size="secondary-sm" class="text-center text-white font-medium">
        Input and confirm your desired EVM wallet for airdrop reception of Albarra pilot season rewards! (Will be sent on ApeChain)
      </Typography>
    </div>
    
    <!-- Wallet address input -->
    <div class="flex flex-col gap-2">
      <input
        v-model="walletAddress"
        type="text"
        placeholder="0x..."
        class="bg-neutral-800 border border-neutral-600 rounded px-4 py-3 text-white placeholder-neutral-400 focus:border-primary focus:outline-none"
        :class="{ 'border-red-500': showError }"
        @input="clearError"
      />
      <Typography v-if="showError" size="secondary-xs" class="text-red-500">
        Please enter a valid wallet address
      </Typography>
    </div>

    <!-- Submit button -->
    <button 
      class="bg-primary text-white font-bold px-6 py-3 mx-auto w-full max-w-sm hover:bg-opacity-90 transition-all disabled:opacity-50"
      :disabled="!walletAddress || isSubmitting"
      @click="submitWalletAddress">
      <Typography size="main-l" class="font-bold">
        {{ isSubmitting ? 'Submitting...' : 'Confirm wallet' }}
      </Typography>
    </button>
  </div>
</template>
  
<script setup>
import Typography from "@/components/common/Typography.vue"
import { useModalsStore } from '../../stores/useModalsStore'
import { useClaimsStore } from '../../stores/useClaimsStore'
import { useAuthStore } from '../../stores/useAuthStore'
import { computed, ref, onMounted } from 'vue'

const modalsStore = useModalsStore()
const claimsStore = useClaimsStore()
const authStore = useAuthStore()

// Obtener los datos de elegibilidad del payload del modal
const eligibility = computed(() => modalsStore.modalPayload)

const walletAddress = ref('')
const showError = ref(false)
const isSubmitting = ref(false)

// Autocompletar con el valor de other_page si existe
onMounted(() => {
  if (authStore.otherPage) {
    walletAddress.value = authStore.otherPage
  }
})

const clearError = () => {
  showError.value = false
}

const validateWalletAddress = (address) => {
  // Validación básica de dirección de wallet (Ethereum)
  const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/
  return ethAddressRegex.test(address)
}

const submitWalletAddress = async () => {
  if (!walletAddress.value.trim()) {
    showError.value = true
    return
  }
  
  if (!validateWalletAddress(walletAddress.value.trim())) {
    showError.value = true
    return
  }
  
  try {
    isSubmitting.value = true
    
    // Llamar al backend para guardar la dirección
    const response = await claimsStore.saveWalletAddress({ 
      wallet_address: walletAddress.value.trim() 
    })
    
    if (response && response.code === 'wallet_address_saved') {
      const VERIFIED_ON_CHAIN_BADGE_ID = 77
      modalsStore.openModal('SUCCESS_CLAIM_VERIFIED_ON_CHAIN_BADGE', { badge_id: VERIFIED_ON_CHAIN_BADGE_ID })
    } else {
      throw new Error('Failed to save wallet address')
    }
    
  } catch (error) {
    console.error('Error submitting wallet address:', error)
    showError.value = true
  } finally {
    isSubmitting.value = false
  }
}
</script>
  
<style scoped>
</style>
